'use client'

import { Typography } from '@/ui/atoms/typography/Typography'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { PointsNavigation } from '@/features/points/components/points-navigation/PointsNavigation'

export default function PointsLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <PageLayout className="max-w-4xl gap-4 px-3">
      <div className="flex max-w-xl flex-col items-start gap-4">
        <div className="flex items-baseline gap-2">
          <Typography variant="h1" className="lg:text-4xl" gradient>
            HypurrFi Points
          </Typography>
        </div>
      </div>

      <PointsNavigation />

      {children}
    </PageLayout>
  )
}
